<template>
  <el-dialog :visible.sync="visible" width="500px" custom-class="premium-dialog" :show-close="false"
    :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
    <div class="premium-header position-relative text-center pb-4 border-bottom">
      <el-button class="position-absolute"
        style="top: 0; right: 0; padding: 6px; border: none; background: #f3f4f6; color: #6b7280; font-size: 16px; border-radius: 6px;"
        icon="el-icon-close" @click="close"></el-button>

      <div class="logo-wrapper mx-auto mb-3 mt-2"
        style="width: 68px; height: 68px; border-radius: 50%; background: #f4f7fb; display: flex; align-items: center; justify-content: center; box-shadow: 0 0 0 1px #e5e7eb;">
        <img src="/logo.png" alt="logo" style="width: 45px; height: 45px;" />
      </div>

      <h3 class="fw-bold mb-2" style="font-size: 20px; color: #111827;">Thông báo Salework Contact</h3>
      <p class="text-muted mb-0" style="font-size: 14px; color: #6b7280;">Cảm ơn bạn đã trải nghiệm trong giai đoạn beta
        miễn phí</p>
    </div>

    <div class="premium-body pt-4">
      <!-- Yellow box -->
      <div class="warning-box mb-3 p-3 rounded"
        style="background-color: #FFFBEB; border: 1px solid #fbeeb8; display: flex; border-radius: 8px !important">
        <div class="icon me-3" style="color: #d97706; font-size: 20px;">
          <i class="el-icon-warning-outline"></i>
        </div>
        <div>
          <div style="color: #92400e; font-size: 14px;">Salework Contact sẽ <span class="fw-bold">bắt đầu tính
              phí</span> từ ngày</div>
          <div class="date-pill d-inline-block mt-2 px-3 py-1 rounded-pill"
            style="background-color: #FFF3C7; color: #b45309; font-weight: 600; font-size: 13px; border: 1px solid #fbeeb8;">
            <i class="el-icon-date me-1"></i> 13/04/2025
          </div>
        </div>
      </div>

      <!-- Blue box -->
      <div class="info-box p-3 rounded d-flex mb-4"
        style="background-color: #f0f5ff; border: 1px solid #d6e4ff; border-radius: 8px !important">
        <div class="icon me-3" style="color: #2563eb; font-size: 18px;">
          <svg style="width: 20px; height: 20px; margin-top: 2px;" fill="none" stroke="currentColor" viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z">
            </path>
          </svg>
        </div>
        <div style="color: #1D4ED8; font-size: 14px; line-height: 1.5;">
          Liên hệ Chăm sóc khách hàng để <span style="font-weight: 700; color: #2563eb;">gia hạn dùng thử thêm 2
            tuần</span> hoặc đăng ký gói dịch vụ.
        </div>
      </div>

      <div class="text-end mb-4 pe-2">
        <a href="https://docs.google.com/forms/d/e/1FAIpQLSdsHY46Tqamup1jJLrhjQJ1gpPl262aD16BNmIV-YFr43bgvA/viewform"
          target="_blank" class="fw-bold" style="font-size: 14px; color: #374151; text-decoration: underline;">Khảo sát
          sản phẩm</a>
      </div>

      <div class="d-flex justify-content-between align-items-center pb-2 px-2">
        <el-checkbox v-if="!isExpire" v-model="hideToday" style="font-weight: normal; color: #6b7280;">Không hiển thị lại trong hôm
          nay</el-checkbox>
        <div v-else></div>
        <el-button plain @click="close"
          style="width: 100px; font-weight: 600; border-color: #d1d5db; color: #4b5563; border-radius: 6px; padding: 10px 20px;">Đã
          hiểu</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "BannerPremium",
  data() {
    return {
      visible: false,
      hideToday: false,
      isExpire: false
    };
  },
  computed: {
    userKey() {
      const gId = this.app?.user?.id || 'guest';
      const gUser = this.app?.user?.swUsername || 'employee';
      return `${gId}_${gUser}`;
    }
  },
  methods: {
    show(isExpire = false) {
      this.isExpire = isExpire;
      if (!isExpire) {
        const settingsStr = localStorage.getItem('hidePremiumBannerSettings');
        if (settingsStr) {
          try {
            const settings = JSON.parse(settingsStr);
            const hideUntil = settings[this.userKey];
            const today = new Date().toISOString().split('T')[0];
            if (hideUntil === today) {
              return; // Already hidden for today
            }
          } catch (e) {
            // Ignore format errors
          }
        }
      }
      this.hideToday = false;
      this.visible = true;
    },
    close() {
      let settings = {};
      try {
        const settingsStr = localStorage.getItem('hidePremiumBannerSettings');
        if (settingsStr) {
          settings = JSON.parse(settingsStr);
        }
      } catch (e) {
        console.log(e);
      }

      const today = new Date().toISOString().split('T')[0];

      if (!this.isExpire && this.hideToday) {
        // Xóa những record cũ không phải ngày hôm nay để giải phóng bộ nhớ
        for (const k in settings) {
          if (settings[k] !== today) {
            delete settings[k];
          }
        }
        // Ghi lại record người hiện tại
        settings[this.userKey] = today;
        localStorage.setItem('hidePremiumBannerSettings', JSON.stringify(settings));
      } else if (!this.isExpire) {
        // Nếu không check thì gỡ record của tài khoản này ra (nếu có)
        if (settings[this.userKey]) {
          delete settings[this.userKey];
          localStorage.setItem('hidePremiumBannerSettings', JSON.stringify(settings));
        }
      }
      this.visible = false;
      this.$emit('close');
    }
  }
}
</script>

<style>
.premium-dialog .el-dialog__header {
  display: none !important;
}

.premium-dialog {
  border-radius: 16px !important;
  overflow: hidden;
}

.premium-dialog .el-dialog__body {
  padding: 20px 20px 20px 20px !important;
  word-break: normal !important;
  overflow-wrap: break-word !important;
}
</style>

<style scoped>
.warning-box {
  border-radius: 12px;
  padding: 20px 24px !important;
  margin-bottom: 24px !important;
}

.info-box {
  border-radius: 12px;
  padding: 20px 24px !important;
  margin-bottom: 32px !important;
}

.premium-header {
  margin-bottom: 8px;
}
</style>
